import { useCallback } from 'react';
import { DepartmentTreeNodeDTO } from '@/api/trafikportalen';

export type SortOptions = 'closed' | 'all' | 'editable' | 'mobile';

interface DepartmentResult {
  selectedId: string | null;
  paths: string[][];
}
export const useGetDepartmentPath = (useDepartmentId?: string) => {
  const sortDepartmentsTree = useCallback(
    (
      department: DepartmentTreeNodeDTO,
      departmentId?: string | undefined,
      sortOptions?: SortOptions | undefined,
      path: string[] = [],
      result: DepartmentResult = {
        selectedId: null,
        paths: [],
      },
    ): DepartmentResult => {
      const currentPath = [...path, department.id];

      if (sortOptions === 'mobile') {
        if (department.admin || department.id === useDepartmentId) {
          result.selectedId ??= departmentId ?? department.id;
          result.paths.push(currentPath);
        }
      }

      if (sortOptions === 'editable' && department.admin) {
        result.selectedId ??= departmentId ?? department.id;
        result.paths.push(currentPath);
      }

      if (sortOptions === 'closed') {
        if (result.paths.length === 0) {
          result.paths.push(currentPath);
        }
      }

      if (sortOptions === 'all') {
        result.paths.push(currentPath);
      }

      for (const child of department.children) {
        sortDepartmentsTree(child, child.id, sortOptions, currentPath, result);
      }

      return result;
    },
    [useDepartmentId],
  );

  return sortDepartmentsTree;
};
